/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-indent */

import React from 'react';
import successImage from '../../assets/CRMLogo.png';

function PaymentSuccess() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      // height: '80vh',
    }}
    >
      <img
        src={successImage}
        height="200px"
        width="200px"
        alt="carsh"
        style={{ padding: '30px' }}
      />
      <h6
        style={{
          fontSize: '30px',
          color: '#1aac10',
          fontWeight: 'bold',
          margin: '0px',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        Payment Successful
      </h6>
      <h6
        style={{
          fontSize: '100px',
          color: '#D5D1D1',
          fontWeight: 'bold',
          margin: '0px',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        Thank You
      </h6>
      <h6
        style={{
          fontSize: '18px',
          color: '#4e4e4e',
          margin: '0px',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        Our Counsellor will contact you soon
      </h6>
    </div>
  );
}

export default PaymentSuccess;
